<div class="" *ngIf="hasConnectedAccount">
  <button class="btn btn-outline-primary"
    [routerLink]="['/marketplace', 'admin', 'products', 'create']">
    Create Product
  </button>
</div>